import { defineStore } from "pinia";

export const useFlashStore = defineStore("flash", {
  state: () => ({
    active: false,
    message: "",
    type: "",
  }),
  actions: {
    setFlash(payload) {
      this.active = true;
      this.message = payload.message;
      this.type = payload.type;
    },
    clearFlash() {
      this.active = false;
      this.message = "";
      this.type = "info";
    },
    setUserMessage(message) {
      this.active = true;
      this.message = message;
      this.type = "info";
    },
  },
});
